
import { Component, Vue } from 'vue-property-decorator'

import BacModal from '@/components/BacModal.vue'
import BacButton from '@/components/BacButton.vue'
import BacLazyImage from '@/components/BacLazyImage.vue'

import { RallyRoundHeaderImage } from '@/lib/models/RallyRoundHeaderImage'
import UIkit from 'uikit'

import { Http } from '@/lib/utils/Http'

@Component({
  components: {
    BacModal,
    BacButton,
    BacLazyImage
  }
})
export default class RallyPictureChooser extends Vue {
  rallyRoundHeaderImages: RallyRoundHeaderImage[] = []
  selectedImageId = -1
  isLoading = false

  mounted () {
    this.loadRallyRoundImages()
  }

  async loadRallyRoundImages () {
    this.rallyRoundHeaderImages = await RallyRoundHeaderImage.getAll({})
  }

  async uploadImage () {
    this.isLoading = true
    const file = ((this.$refs as any).imageUpload as any).files[0]
    const reader = new FileReader()
    reader.addEventListener('load', async (e) => {
      if (!e.target || !e.target.result) {
        throw new Error('Something bad happened trying to load image in FileReader! No Target or Target Result!')
      }
      const base64ImageData = btoa(e.target.result as string)
      const res = await Http.request('/api/rally-round-header-image', {
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
          name: file.name,
          type: file.type,
          image: base64ImageData
        })
      })
      try {
        const resData = await res.json()
        if (res.status === 200) {
          UIkit.notification({
            message: 'Daten gespeichert!',
            status: 'success',
            timeout: 5000,
            pos: 'bottom-center'
          })
          this.$emit('successfullSave')
          this.loadRallyRoundImages()
        } else {
          UIkit.notification({
            message: 'Daten nicht gespeichert, etwas ging schief! Bitte kontaktiere uns sollte das Problem bestehen bleiben!',
            status: 'success',
            timeout: 5000,
            pos: 'bottom-center'
          })
          console.error('error saving image, response: ', resData)
        }
      } catch (ex) {
        UIkit.notification({
          message: 'Daten nicht gespeichert, etwas ging schief! Bitte kontaktiere uns sollte das Problem bestehen bleiben!',
          status: 'success',
          timeout: 5000,
          pos: 'bottom-center'
        })
        console.error('exception saving image, response: ', ex)
      }
    })
    reader.readAsBinaryString(file)
  }

  async saveRallyRoundHeaderImage () {
    await Http.request(`/api/rally-round/${this.$route.params.rallyRoundId}/`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        headerImage: this.selectedImageId
      })
    })
    UIkit.modal('#choose-header-image').hide()
    this.$store.dispatch('forceReloadRallyRound', this.$route.params.rallyRoundId)
  }
}
